import getGlobal from './getGlobal';

function hasGlobalProperty(property: keyof typeof window): boolean {

    const global = getGlobal();
    return (global as any)[property] !== undefined;
}

export default hasGlobalProperty;
